var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDownLong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 329.375C21.882 316.868 42.132 316.882 54.625 329.375L128 402.75V32C128 14.312 142.312 0 160 0S192 14.312 192 32V402.75L265.375 329.375C277.875 316.875 298.125 316.875 310.625 329.375S323.125 362.125 310.625 374.625L182.625 502.625C170.125 515.125 149.875 515.125 137.375 502.625L9.375 374.625C-3.125 362.125 -3.125 341.875 9.375 329.375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownLong);
export default __webpack_public_path__ + "static/media/arrow-down-long.844a4dae2547424b67c577cd45b46e74.svg";
export { ForwardRef as ReactComponent };